<template>
  <div class="wrapper">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <section class="section01">
            <div class="object01">
              {{ $t('al001.alarmBox') }}
            </div>
          </section>
          <section class="section02">
            <!-- 알림 없을때(Class) : none -->
            <div class="object01" :class="alarmList !== null && !alarmList.length ? 'none' : ''">
              <div class="item" v-for="alarm in alarmList" :key="alarm.alarm_id" @click="moveMenu(`/${alarm.landingId.replace(/-/g,'')}`)">
                <div class="item01">
                  <div class="title">
                    <div class="caption">
                      {{ alarm.title }}
                    </div>
                    <div class="date">
                      {{ agoDate(alarm.insert_dt) }}
                    </div>
                  </div>
                  <div class="content">
                    {{ alarm.message }}
                  </div>
                </div>
                <div class="item02">
                  <div class="more">
                    {{ $t('al001.viewDetails') }}
                  </div>
                </div>
              </div>
              <div class="none">
                {{ $t('al001.noAlarms') }}
              </div>
            </div>
          </section>
        </div>
      </main>
      <footerLayout></footerLayout>
      <!-- 확인만(Class) : typeConfirm -->
      <div class="alert typeConfirm">
        <div class="container">
          <div class="outer">
            <div class="inner">
              <div class="box">
                <div class="zone">
                  <div class="body">
                    {{ $t('al001.answerNoticeLine1') }}<br />
                    {{ $t('al001.answerNoticeLine2') }}<br />
                    {{ $t('al001.answerConfirm') }}
                  </div>
                  <div class="footer">
                    <button class="cancel">
                      {{ $t('common.cancel') }}
                    </button>
                    <button class="confirm">
                      {{ $t('common.confirm') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* Layout */
import LeftLayout from './layout/Left.vue'
import HeaderLayout from './layout/Header.vue'
import FooterLayout from './layout/Footer.vue'
import {settingService, userService} from '../router'
import moment from 'moment'

export default {
  name: 'AL001',
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout
  },
  data () {
    return {
      alarmList: null
    }
  },
  created: function () {
    moment.locale(this.$i18n.locale)
    userService.getAll().then(response => {
      this.userInfo = response.data
    })
  },
  mounted: function () {
    this.setData()
  },
  methods: {
    setData: function () {
      settingService.getPushAlarmList(1, 5).then(response => {
        this.alarmList = response.alarmList || []
      }).catch(error => {
        console.log('getAlarmList.err.===>', error)
      })
    },
    agoDate: function (date) {
      let now = moment()
      let isrtDt = moment(date)
      if (now.diff(isrtDt, 'hours') < 24) return isrtDt.fromNow()
      return isrtDt.format('YYYY-MM-DD')
    }
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AL001.vue